import React, { useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import { Grid } from '@mantine/core';
import * as Unicons from '@iconscout/react-unicons';
import { useDisclosure } from '@mantine/hooks';
import ModalChangeInterest from '../edit_profile_user/ModalChangeInterest';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import TableImage from '../../components/fragments/TableImage';
import LabelDate from '../../components/fragments/LabelDate';
import BadgeTable from './BadgeTable';
import MissionTable from './MissionTable';
import LadderboardTable from './LadderboardTable';
import ChartPerbandinganLevel from './ChartPerbandinganLevel';
import ChartRiwayatRedeem from './ChartRiwayatRedeem';
import ChartRiwayatCompletionMission from './ChartRiwayatCompletionMission';
import ChartPerbandinganPoint from './ChartPerbandinganPoint';
import TopMission from './TopMission';
import TopVoucher from './TopVoucher';

const ReportGamificationPage = (props) => {
  const [openedInterest, { toggle: toggleInterest }] = useDisclosure(false);

  return (
    <>
      <AdminLayout>
        <Breadcrumbs
          pageTitle="Overview"
          itemList={[
            {
              title: 'Back Office BCL&D',
              href: '#',
              icon: <Unicons.UilFileCopyAlt size={16} />
            },
            {
              title: 'Reward & Gamification',
              href: '#'
            },
            {
              title: 'Report Gamification',
              href: '/management/report-gamification'
            }
          ]}
        />
        <Grid>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <ChartPerbandinganLevel />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <ChartRiwayatRedeem />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <ChartRiwayatCompletionMission />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <ChartPerbandinganPoint />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <TopMission />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
            <TopVoucher />
          </Grid.Col>
          <Grid.Col span={12}>
            <BadgeTable />
          </Grid.Col>
          <Grid.Col span={12}>
            <MissionTable />
          </Grid.Col>
          <Grid.Col span={12}>
            <LadderboardTable />
          </Grid.Col>
        </Grid>
      </AdminLayout>
      <ModalChangeInterest
        onClose={() => toggleInterest()}
        opened={openedInterest}
      />
    </>
  );
};

export default ReportGamificationPage;
